import { useMutation, useQueryClient } from 'react-query';
import {
  createChatRoom,
  type CreateChatRoomBody,
  type CreateChatRoomResponse
} from '../../services/chatService';

export function useCreateChatRoom() {
  const queryClient = useQueryClient();
  return useMutation<CreateChatRoomResponse, Error, CreateChatRoomBody>(
    (body) => createChatRoom(body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['AllChatRooms']);
      }
    }
  );
}
